// Stateless components

export function PageBreadcrumb(props) {

    //
    // Render
    //

    var page_title = props['title'];
    var breadcrumb_link = props['link'];
    var breadcrumb_text = props['linkText'];

    return (
        <div className="page-breadcrumb__wrapper">
            <div className="inner">
                <h1 className="visuallyhidden">{page_title}</h1>
                <a href={breadcrumb_link} className="page-breadcrumb__link">
                    <span className="page-breadcrumb__back"></span>
                    {breadcrumb_text}
                </a>
            </div>
        </div>
    )

};
